import {defineStore} from "pinia";
import {computed, ref} from "vue";
import * as CmsService from "@/services/cms.service";
import {Page} from "@/models/Page";

export const usePageStore = defineStore('pages', () => {

    const loading = ref(false);
    const firstPage = ref<Page>({
        imageSet: {
            '380w': false
        }
    });

    const pageList = ref<Page[]>([]);

    const hasPages = computed(() => firstPage.value || pageList.value);

    function getAll(slug: string) {
        loading.value = true;

        CmsService.getChildren(slug).then((data) => {
            firstPage.value = data.data.pop()
            // console.log("First Page", firstPage.value)
            pageList.value = data.data
            // console.log(pageList.value)
        }).catch(() => {
            firstPage.value = undefined;
            pageList.value = []
        })
            .finally(() => {
                loading.value = false;
            })

    }

    function getPage(slug: string) {
        return CmsService.getPageContents(slug)
    }

    return {loading, firstPage, pageList, hasPages, getAll, getPage}

});